import React from "react";
import Footer from "./footer";
import { Outlet } from "react-router-dom";

const Layouts = (props) => {
  return (
    <>
      <Outlet />
      <Footer />
    </>
  )
}

export default Layouts